// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Imported from:
https://github.com/forkphorus/forkphorus/tree/master/studioview
With changes to make it work properly in the scratch-gui environment.
*/

/* we wrap it in a <div> */

.featured-projects_wrapper_Ei71y {
  height: 100%;
}

/* fix some styles that can be messed up by scratch-gui */

.featured-projects_featured-projects-root_BQW9o * {
  box-sizing: content-box !important;
}

.featured-projects_featured-projects-root_BQW9o {
  height: 100%;
}

.featured-projects_featured-projects-list_eGyTk {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-anchor: none;
}

.featured-projects_featured-projects-project_HANeI, .featured-projects_featured-projects-placeholder_vzD3Y {
  display: inline-block;
  width: 144px;
  padding: 3px;
  margin-bottom: 1px;
  margin-right: 1px;
}

.featured-projects_featured-projects-root_BQW9o .featured-projects_featured-projects-project_HANeI {
  color: inherit;
  position: relative;
  text-decoration: none;
}

.featured-projects_featured-projects-loaded_JMpnl:hover::before, .featured-projects_featured-projects-loaded_JMpnl:active::before {
  content: '';
  pointer-events: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: currentColor;
  opacity: 0.1;
}

.featured-projects_featured-projects-root_BQW9o .featured-projects_featured-projects-loaded_JMpnl:active::before {
  opacity: 0.2;
}

.featured-projects_featured-projects-root_BQW9o .featured-projects_featured-projects-title_E7NZD,
.featured-projects_featured-projects-root_BQW9o .featured-projects_featured-projects-author_Jw7MO {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  text-decoration: none;
}

.featured-projects_featured-projects-title_E7NZD {
  font-size: 0.8em;
  font-weight: bold;
}

.featured-projects_featured-projects-author_Jw7MO {
  font-size: 0.75em;
}

.featured-projects_featured-projects-error_oBlHC {
  width: 100%;
}

.featured-projects_featured-projects-thumbnail_ZOsNg, .featured-projects_featured-projects-placeholder-thumbnail_ntXpM {
  position: relative;
  width: 144px;
  height: 108px;
}

.featured-projects_featured-projects-thumbnail_ZOsNg::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: currentColor;
  opacity: 0.1;
}

.featured-projects_featured-projects-thumbnail_ZOsNg img {
  width: 100%;
  height: 100%;
}

.featured-projects_featured-projects-placeholder_vzD3Y .featured-projects_featured-projects-thumbnail_ZOsNg,
.featured-projects_featured-projects-placeholder_vzD3Y .featured-projects_featured-projects-title_E7NZD,
.featured-projects_featured-projects-placeholder_vzD3Y .featured-projects_featured-projects-author_Jw7MO {
  background-color: currentColor;
  opacity: 0.1;
}

.featured-projects_featured-projects-title_E7NZD {
  height: 20px;
  margin-top: 2px;
}

.featured-projects_featured-projects-author_Jw7MO {
  height: 18px;
}

.featured-projects_featured-projects-placeholder_vzD3Y .featured-projects_featured-projects-title_E7NZD {
  border-radius: 2px 2px 2px 0;
  width: 100%;
}

.featured-projects_featured-projects-placeholder_vzD3Y .featured-projects_featured-projects-author_Jw7MO {
  border-radius: 0 0 2px 2px;
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-featured-projects/featured-projects.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED,0BAA0B;;AAE1B;EACE,YAAY;AACd;;AAEA,yDAAyD;;AAEzD;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ","sourcesContent":["/*\nImported from:\nhttps://github.com/forkphorus/forkphorus/tree/master/studioview\nWith changes to make it work properly in the scratch-gui environment.\n*/\n\n/* we wrap it in a <div> */\n\n.wrapper {\n  height: 100%;\n}\n\n/* fix some styles that can be messed up by scratch-gui */\n\n.featured-projects-root * {\n  box-sizing: content-box !important;\n}\n\n.featured-projects-root {\n  height: 100%;\n}\n\n.featured-projects-list {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n  overflow-anchor: none;\n}\n\n.featured-projects-project, .featured-projects-placeholder {\n  display: inline-block;\n  width: 144px;\n  padding: 3px;\n  margin-bottom: 1px;\n  margin-right: 1px;\n}\n\n.featured-projects-root .featured-projects-project {\n  color: inherit;\n  position: relative;\n  text-decoration: none;\n}\n\n.featured-projects-loaded:hover::before, .featured-projects-loaded:active::before {\n  content: '';\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: currentColor;\n  opacity: 0.1;\n}\n\n.featured-projects-root .featured-projects-loaded:active::before {\n  opacity: 0.2;\n}\n\n.featured-projects-root .featured-projects-title,\n.featured-projects-root .featured-projects-author {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  color: inherit;\n  text-decoration: none;\n}\n\n.featured-projects-title {\n  font-size: 0.8em;\n  font-weight: bold;\n}\n\n.featured-projects-author {\n  font-size: 0.75em;\n}\n\n.featured-projects-error {\n  width: 100%;\n}\n\n.featured-projects-thumbnail, .featured-projects-placeholder-thumbnail {\n  position: relative;\n  width: 144px;\n  height: 108px;\n}\n\n.featured-projects-thumbnail::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: currentColor;\n  opacity: 0.1;\n}\n\n.featured-projects-thumbnail img {\n  width: 100%;\n  height: 100%;\n}\n\n.featured-projects-placeholder .featured-projects-thumbnail,\n.featured-projects-placeholder .featured-projects-title,\n.featured-projects-placeholder .featured-projects-author {\n  background-color: currentColor;\n  opacity: 0.1;\n}\n\n.featured-projects-title {\n  height: 20px;\n  margin-top: 2px;\n}\n\n.featured-projects-author {\n  height: 18px;\n}\n\n.featured-projects-placeholder .featured-projects-title {\n  border-radius: 2px 2px 2px 0;\n  width: 100%;\n}\n\n.featured-projects-placeholder .featured-projects-author {\n  border-radius: 0 0 2px 2px;\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `featured-projects_wrapper_Ei71y`;
var _1 = `featured-projects_featured-projects-root_BQW9o`;
export { _1 as "featured-projects-root" };
export var featuredProjectsRoot = `featured-projects_featured-projects-root_BQW9o`;
var _2 = `featured-projects_featured-projects-list_eGyTk`;
export { _2 as "featured-projects-list" };
export var featuredProjectsList = `featured-projects_featured-projects-list_eGyTk`;
var _3 = `featured-projects_featured-projects-project_HANeI`;
export { _3 as "featured-projects-project" };
export var featuredProjectsProject = `featured-projects_featured-projects-project_HANeI`;
var _4 = `featured-projects_featured-projects-placeholder_vzD3Y`;
export { _4 as "featured-projects-placeholder" };
export var featuredProjectsPlaceholder = `featured-projects_featured-projects-placeholder_vzD3Y`;
var _5 = `featured-projects_featured-projects-loaded_JMpnl`;
export { _5 as "featured-projects-loaded" };
export var featuredProjectsLoaded = `featured-projects_featured-projects-loaded_JMpnl`;
var _6 = `featured-projects_featured-projects-title_E7NZD`;
export { _6 as "featured-projects-title" };
export var featuredProjectsTitle = `featured-projects_featured-projects-title_E7NZD`;
var _7 = `featured-projects_featured-projects-author_Jw7MO`;
export { _7 as "featured-projects-author" };
export var featuredProjectsAuthor = `featured-projects_featured-projects-author_Jw7MO`;
var _8 = `featured-projects_featured-projects-error_oBlHC`;
export { _8 as "featured-projects-error" };
export var featuredProjectsError = `featured-projects_featured-projects-error_oBlHC`;
var _9 = `featured-projects_featured-projects-thumbnail_ZOsNg`;
export { _9 as "featured-projects-thumbnail" };
export var featuredProjectsThumbnail = `featured-projects_featured-projects-thumbnail_ZOsNg`;
var _a = `featured-projects_featured-projects-placeholder-thumbnail_ntXpM`;
export { _a as "featured-projects-placeholder-thumbnail" };
export var featuredProjectsPlaceholderThumbnail = `featured-projects_featured-projects-placeholder-thumbnail_ntXpM`;
export default ___CSS_LOADER_EXPORT___;
